import { AGENT_DASHBOARD_ENABLED } from '../config/features';

export const isAdminLoginPath = pathname => pathname === '/' || pathname === '/login';

// Agent profiles may omit role or use MANAGER with an explicit agent ID.
// MANAGER alone also describes administrator accounts, so it is not sufficient.
export function isAgentUser(user) {
    const hierarchyAgent = user?.isAdmin === false && Number.isInteger(user?.level) && user.level > 0;
    const managerAgent = user?.role === 'MANAGER' && typeof user?.agent_id === 'string' && user.agent_id.trim().length > 0;
    return user?.role === 'AGENT' || (hierarchyAgent && (!user?.role || managerAgent));
}

export function getAdminLoginDestination(user) {
    if (user?.role === 'SUPER') return '/dashboard';
    if (canViewAgentDashboard(user)) return '/agentDashboard';
    if (user?.role !== 'SM' && user?.wallet_use_yn === 'Y') return '/agentWallet';
    return '/paylist';
}

// Settlement-view permission does not identify the account as an agent.
export function canViewAgentDashboard(user) {
    return AGENT_DASHBOARD_ENABLED && user?.isAdmin !== true && isAgentUser(user);
}

export function canViewAgentWallet(user, screens = []) {
    return user?.wallet_use_yn === 'Y' && (isAgentUser(user) || screens.includes('에이전트 정산내역'));
}
